const translations = {
	page_title: "Create partner",
	sub_pages: {
		create_office: {
			title: "Création / Sélection d'un cabinet",
			find_office: "Chercher un cabinet",
			existing_office: "Cabinet existant",
			new_office: "Nouveau Cabinet",
			legal_identity: "Identité juridique",
			authorisation: "Habilitations & autorisations",
			manager_data: "Données du représentant légal",
			office_coordinates: "Coordonnées du cabinet",
			bank_data: "Données bancaires (commissions)",
			office_products: "Les produits auxquels le cabinet a accès",
			check_all_spci: "Cocher toutes les SCPI",
			form: {
				company_name: {
					label: "Raison sociale *",
					placeholder: "Raison sociale",
				},
				siret: {
					label: "Numéro d'identification de l'entreprise (SIRET, RIDET, T.A.H.I.T.I) *",
					placeholder: "Numéro d'identification de l'entreprise",
				},
				legal_form: {
					label: "Forme juridique *",
					placeholder: "Choisir",
				},
				rcs: {
					label: "RCS *",
					placeholder: "Lieu du RCS",
				},
				share_capital: {
					label: "Capital social *",
					placeholder: "Montant du capital social",
				},
				membre_reseau: {
					label: "Membre d'un réseau",
					placeholder: "Nom du réseau",
				},
				type_advisor: {
					label: "Type du conseiller *",
					placeholder: "Choisir le type",
				},
				habilitations: {
					label: "Habilitations *",
				},
				professional_association: {
					label: "Association professionnelle *",
					placeholder: "Entrer l'association",
				},
				numero_orias: {
					label: "N°Orias *",
					placeholder: "N°Orias",
				},
				business_lines: {
					label: "Ligne de metier *",
				},
				name: {
					label: "Nom *",
					placeholder: "Nom",
				},
				first_name: {
					label: "Prénom *",
					placeholder: "Prénom",
				},
				birth_date: {
					label: "Date de naissance *",
				},
				email_manager: {
					label: "Email du gérant *",
					placeholder: "Indiquer l'email",
				},
				email_administratif: {
					label: "Email administratif",
					placeholder: "Indiquer l'email",
				},
				phone_number: {
					label: "N° de téléphone fixe",
					placeholder: "N° de téléphone fixe",
				},
				address: {
					label: "Adresse (n° + rue + ville + code postal) *",
					placeholder: "Adresse (n° + rue + ville + code postal)",
				},
				account_owner: {
					label: "Titulaire du compte *",
					placeholder: "Titulaire du compte",
				},
				iban: {
					label: "IBAN *",
					placeholder: "IBAN",
				},
				bic: {
					label: "BIC *",
					placeholder: "BIC",
				},
			},
		},
		create_cgp: {
			title: "Création d'un CGP",
			data_advisor: "Données du conseiller",
			partner_account: "Compte partenaire",
			message_no_office_selected: "Aucun cabinet n'a été créé ou selectionné, veuillez revenir à l'étape précédente",
			fill_with_manager_data: "Remplir avec les données du représentant légal",
			form: {
				last_name: {
					label: "Nom *",
					placeholder: "Nom",
				},
				first_name: {
					label: "Prénom *",
					placeholder: "Prénom",
				},
				birth_date: {
					label: "Date de naissance *",
				},
				email: {
					label: "Email principal (adresse email de connexion) *",
					placeholder: "Indiquer l'email",
				},
				phone_number: {
					label: "N° de téléphone mobile *",
					placeholder: "N° de téléphone mobile",
				},
				etat_compte: {
					label: "Etat du compte *",
					placeholder: "Etat du compte",
				},
				signature_date: {
					label: "Date de signature *",
				},
				creation_date: {
					label: "Date de création *",
				},
			},
		},
	},
	back: "Retour au Middle Office",
};

export default translations;
